import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
} from "@mui/material";
import GlobalButton from "../../common/GlobalButton";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import BackWithArrow from "../../common/BackWithArrow";
import PutIdeasIconDesign from "../../common/PutIdeasIconDesign";

export default function PutIdeaButton({ onSubmit }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    submittedBy: "",
    date: new Date().toISOString().substring(0, 10),
  });

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit(formData);
    setOpen(false);
    setFormData({
      title: "",
      submittedBy: "",
      date: new Date().toISOString().substring(0, 10),
    });
  };

  return (
    <>
      <PutIdeasIconDesign onClick={() => setOpen(true)} />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        PaperProps={{
          sx: {
            minHeight: "100vh",
            maxHeight: "100vh",
            background: "white",
          },
        }}
      >
        <BackWithArrow onBack={() => setOpen(false)} />

        {/* <DialogTitle>Submit New CI Idea</DialogTitle> */}
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Idea Title"
              value={formData.title}
              onChange={handleChange("title")}
              fullWidth
              required
            />
            <TextField
              label="Submitted By"
              value={formData.submittedBy}
              onChange={handleChange("submittedBy")}
              fullWidth
              required
            />
            <TextField
              label="Date"
              type="date"
              value={formData.date}
              onChange={handleChange("date")}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Description"
              multiline
              rows={3}
              fullWidth
              onChange={handleChange("description")}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <GlobalButton
            icon={<RestartAltIcon />}
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Reset
          </GlobalButton>
          <GlobalButton icon={<SaveIcon />} onClick={handleSubmit}>
            Save
          </GlobalButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
